<template>
  <div>
    <!-- Media -->
    <b-media class="mb-2">
      <template #aside>
        <b-avatar
          ref="previewEl"
          :src="userData.avatar"
          size="90px"
          rounded
        />
      </template>
      <h4 class="mb-1">
        {{ userData.titleName }} {{ userData.firstName }} {{ userData.lastName }}
      </h4>
      <span class="card-text">{{ userData.idCardNumber }}</span>
    </b-media>

    <!-- Header: Personal Info -->
    <div class="d-flex">
      <feather-icon
        icon="MapPinIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50">
        Address Information
      </h4>
    </div>

    <!-- Form: Personal Info Form -->
    <b-form class="mt-1">
      <b-row>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Mobile"
            label-for="mobile"
          >
            <b-form-input
              id="mobile"
              v-model="userData.mobile"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="email"
            label-for="email"
          >
            <validation-provider
              #default="{ errors }"
              name="Email"
              rules="email"
            >
              <b-form-input
                id="email"
                v-model="userData.email"
                :state="errors.length > 0 ? false:null"
                type="email"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Address Details"
            label-for="addressDetail"
          >
            <b-form-input
              id="addressDetail"
              v-model="userData.addressDetail"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Sub District"
            label-for="subDistrict"
          >
            <v-select
              v-model="userData.subDistrict"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="subDistrictOptions"
              :reduce="val => val.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="District"
            label-for="district"
          >
            <v-select
              v-model="userData.district"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="districtOptions"
              :reduce="val => val.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Province"
            label-for="province"
          >
            <v-select
              v-model="userData.province"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="provinceOptions"
              :reduce="val => val.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Zip Code"
            label-for="zipCode"
          >
            <b-form-input
              id="zipCode"
              v-model="userData.zipCode"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <hr>

      <contact-address-list :user-address-list="userData.addressInformation" />

      <b-row class="mt-2">
        <b-col>
          <b-button
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          >
            Save Changes
          </b-button>
          <b-button
            variant="outline-secondary"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          >
            Reset
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BFormInput,
  BFormRadioGroup, BFormCheckboxGroup, BButton,
  BMedia, BAvatar,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import ContactAddressList from '../contacts-address/ContactAddressList.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    vSelect,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BMedia,
    BAvatar,
    
    // Form Validation
    ValidationProvider,
    ValidationObserver,

    ContactAddressList,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
    }
  },
  setup() {
    const subDistrictOptions = [
      { label: '', value: '' },
    ]

    const districtOptions = [
      { label: '', value: '' },
    ]

    const provinceOptions = [
      { label: '', value: '' },
    ]

    return {
      subDistrictOptions,
      districtOptions,
      provinceOptions,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
